'use strict';

frontendApp.directive('iioPopover', ['$rootScope', '$interpolate', '$document', '$uibTooltip', function ($rootScope, $interpolate, $document, $uibTooltip) {

  var body = $document.find('html');
  var tt = $uibTooltip('iioPopover', 'popover', 'iioPopoverOpen');
  var currentPopup = null;

  var closeOpenPopover = function () {
    if (currentPopup != null) {
      body.unbind('click');
      currentPopup.triggerHandler('iioPopoverClose');
      currentPopup = null;
    }
  };

  var openPopup = function (element) {
    element.triggerHandler('iioPopoverOpen');
    currentPopup = element;
  };

  return {
    restrict: 'EA',
    scope: true,
    link: function (scope, element, attrs) {

      element.bind('click', function (evt) {

        evt.stopPropagation();

        // If clicking on one that's already open,
        // the intention is to close
        if (scope.tt_isOpen) {
          closeOpenPopover();
          return;
        }

        // Close last opened one, open this one
        closeOpenPopover();
        openPopup(element);

        body.bind('click', function (evt) {
          if ($(evt.target).closest('.popover').length == 0) {
            closeOpenPopover();
          }
        });

      });

      var newAttrs = angular.extend(attrs, {popover: attrs.iioPopover});
      attrs.$observe('iioPopover', function (val) {
        newAttrs.popover = val;
      });

      tt.link.call(this, scope, element, newAttrs);
    }
  };
}]);
